import { Timestamp } from 'firebase/firestore';

// ============================================
// Workshop V2 - Nouveau modèle
// ============================================

export enum BookingMode {
  SOLO = 'SOLO',
  DUO = 'DUO',
  SOLO_DUO = 'SOLO_DUO',
}

export type WorkshopType = 'public' | 'health' | 'teambuilding';

/**
 * Règle de fermeture automatique des réservations.
 * - NONE : ouvert jusqu'au début de l'atelier (comportement historique)
 * - DAY_BEFORE_18H : ferme la veille à 18h, heure de Paris
 * - CUSTOM : ferme à une date/heure choisie
 */
export type ClosingRule = 'NONE' | 'DAY_BEFORE_18H' | 'CUSTOM';

export interface WorkshopV2 {
  id: string;
  title: string;
  description: string;
  type: WorkshopType;
  date: Timestamp;
  duration: number;
  location: string;
  bookingMode: BookingMode;
  priceSolo: number;
  priceDuo: number;
  maxParticipants: number;
  remainingPlaces: number;
  imageUrl: string;
  active: boolean;
  /** Règle choisie par l'admin. Absente sur les ateliers créés avant la fonctionnalité. */
  closingRule?: ClosingRule;
  /**
   * Instant de fermeture des réservations, recalculé depuis `closingRule` et
   * `date` à chaque sauvegarde. C'est ce champ — et lui seul — que lisent le
   * dashboard et le site vitrine. `null` = ouvert jusqu'au début de l'atelier.
   */
  bookingClosesAt?: Timestamp | null;
  createdBy: string;
  createdAt: Timestamp;
}

// ============================================
// Workshop V1 - Ancien modèle (deprecated)
// ============================================

/** @deprecated Utiliser WorkshopV2 à la place */
export interface Workshop {
  id: string;
  title: string;
  description: string;
  type: 'public' | 'health' | 'teambuilding';
  subtype: 'beginner' | 'advanced' | 'duo' | null;
  date: Timestamp;
  duration: number;
  recurrence: 'one-time' | 'monthly' | 'weekly' | null;
  location: string;
  price: number;
  maxParticipants: number;
  remainingPlaces: number;
  imageUrl: string;
  active: boolean;
  createdBy: string;
  createdAt: Timestamp;
}
